module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-toolbar', {
    ref: "main-toolbar",
    staticClass: "amber",
    attrs: {
      "fixed": ""
    }
  }, [(!_vm.isTopLevel) ? _c('v-btn', {
    attrs: {
      "icon": "",
      "light": ""
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.back()
      }
    }
  }, [_c('v-icon', [_vm._v("arrow_back")])], 1) : _c('v-toolbar-side-icon', {
    attrs: {
      "light": ""
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.toggleSidebar()
      }
    }
  }), _vm._v(" "), _c('v-toolbar-title', {
    staticClass: "d-flex",
    staticStyle: {
      "position": "relative"
    },
    domProps: {
      "textContent": _vm._s(_vm.$store.state.nav.title)
    }
  }), _vm._v(" "), _c('v-spacer'), _vm._v(" "), (_vm.showProfile()) ? _c('div', {
    staticClass: "hidden-sm-and-down"
  }, [_c('v-menu', {
    attrs: {
      "offset-y": ""
    }
  }, [_c('v-avatar', {
    attrs: {
      "slot": "activator"
    },
    slot: "activator"
  }, [_c('img', {
    attrs: {
      "alt": _vm.profile.name,
      "src": _vm.profile.picture
    }
  })]), _vm._v(" "), _c('v-card', [_c('v-list', {
    attrs: {
      "three-line": "",
      "dense": ""
    }
  }, [_c('v-list-tile', {
    attrs: {
      "avatar": ""
    }
  }, [_c('v-list-tile-avatar', [_c('img', {
    attrs: {
      "src": _vm.profile.picture
    }
  })]), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', {
    domProps: {
      "innerHTML": _vm._s(_vm.profile.name)
    }
  }), _vm._v(" "), _c('v-list-tile-sub-title', {
    staticClass: "grey--text text--darken-4",
    domProps: {
      "innerHTML": _vm._s(_vm.profile.email)
    }
  }), _vm._v(" "), _c('v-list-tile-sub-title', {
    domProps: {
      "innerHTML": _vm._s(_vm.profile.sub)
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "primary": "",
      "flat": ""
    },
    on: {
      "click": function($event) {
        _vm.signOut()
      }
    }
  }, [_vm._v("Sign out")])], 1)], 1)], 1)], 1) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6ed7ff1c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/MainToolbar.vue
// module id = 339
// module chunks = 2